export default __webpack_public_path__ + "static/media/pickuponly_active.78da7b31.svg";